angular.module('app').directive('tagFilterChips', function() {
    return {
        restrict: 'A',
        link: function(scope, element) {
            var el = element[0];

            // angular-material's md-menu closes on any click whose nearest
            // BUTTON/MD-BUTTON/ng-click ancestor lacks `md-prevent-menu-close`.
            // The chip-remove buttons are rendered dynamically by md-chips,
            // so tag them as they appear.
            function tagRemoveButtons() {
                el.querySelectorAll('button.md-chip-remove').forEach(function(btn) {
                    if (!btn.hasAttribute('md-prevent-menu-close')) {
                        btn.setAttribute('md-prevent-menu-close', 'md-prevent-menu-close');
                    }
                });
            }

            tagRemoveButtons();
            var observer = new MutationObserver(tagRemoveButtons);
            observer.observe(el, { childList: true, subtree: true });

            scope.$on('$destroy', function() {
                observer.disconnect();
            });
        }
    };
});
